import React from 'react';
import FormikDescription from 'gui/components/formikDescription';

export interface IHotelDescriptionProps {
  name?: string;
  values?: any;
}

const HotelDescription = (props: IHotelDescriptionProps) => {
  return (
    <FormikDescription
      name={props.name}
      values={props.values}
      label={`תאור בית מלון(פירוט על החדר, נוף ועוד, ניתן להעתיק מגוגל ומקורות נוספים)`}
    />
  );
};

HotelDescription.defaultProps = {
  name: "hotelDescription",
  values: {},
};

export default React.memo(HotelDescription);
